/** Keep a committed mutation successful even when response hydration fails. */
export async function refreshUploadResult(readCurrent, result = {}) {
  try {
    return { ...result, snapshot: (await readCurrent()).snapshot }
  } catch {
    return {
      ...result,
      warnings: [...(result.warnings ?? []), 'ATTACHMENT_UPLOAD.REFRESH_FAILED']
    }
  }
}
